<div class="page-container" [class.loading]="isLoading">
    @if (taxReturn) {
        <app-header
            [title]="
                (taxReturn.isAmendment ? 'payroll.taxReturns.annualReturnAmended' : 'payroll.taxReturns.annualReturn')
                    | translate: { year }
            "
            [badgeOptions]="taxReturn.stateBadge"
            [back]="true"
            [backRoute]="'..'"
            [contextMenu]="!!hasQcPayrollFlag() && !taxReturn.isComplete"
            contextMenuType="material"
        >
            <button mat-menu-item (click)="deleteTaxPackage('ALL')">{{ 'delete' | translate }}</button>
            <div class="buttons">
                @if (taxReturn.isComplete) {
                    <ui-button type="outline" (click)="handleCreateAmendment()">{{
                        'payroll.taxForms.createAmendment' | translate
                    }}</ui-button>
                }
            </div></app-header
        >

        @if (craFilingDeadline) {
            <ui-banner variant="info">
                {{
                    'payroll.taxReturns.finalizeAndSubmitYourEmployerTaxPackageByDateToEnsureYouMeetTheC'
                        | translate: { date: craFilingDeadline | appDate: 'longDate' }
                }}
            </ui-banner>
        }

        @if (employerTaxPackagesTable(); as employerTaxPackagesTable) {
            <ui-card class="tax-packages" [withMargin]="false" [withSpacing]="false">
                <app-table
                    [title]="'payroll.taxReturns.employerTaxPackages' | translate"
                    [table]="employerTaxPackagesTable"
                    (action)="handleEmployerTaxPackagesAction($event)"
                    (menuItemSelected)="handleEmployerTaxPackagesMenuEvent($event)"
                    [showSearch]="false"
                    [showPagination]="false"
                    [isResponsive]="true"
                    [showOffset]="true"
                    [noPadding]="true"
                    [embedded]="true"
                ></app-table>
            </ui-card>
        }

        @if (t4Summary()?.t619State === 'error') {
            <ui-banner variant="danger" class="margin-bottom-3">
                {{ 'payroll.taxReturns.atLeastOneTaxFormContainsAnErrorOrIsMissingARequiredValueUpdateT' | translate }}
            </ui-banner>
        }

        <app-tax-return-forms-tables
            [t4Summary]="t4Summary()"
            [rl1Summary]="rl1Summary()"
            (downloadPreview)="downloadTaxReturnPreviews($event)"
            (addAmendedTaxForm)="currentlyOpenDialog = 'ADD_AMENDED_TAX_FORM'"
            (sendFormsToEmployees)="sendFormsToEmployees($event)"
            (employeeTaxFormEvent)="handleEmployeeTaxFormEvent($event)"
        />

        <div class="summaries">
            @if (t4Summary(); as t4Summary) {
                <app-t4-summary-details [t4Summary]="t4Summary" />
            }
            @if (rl1Summary(); as rl1Summary) {
                <app-rl1-summary-details [rl1Summary]="rl1Summary" />
            }
        </div>
    }
</div>

<ui-confirmation-dialog
    #deletePackageConfirmationDialog
    [header]="
        'payroll.taxForms.' + packageTypeToBeDeleted + '.deleteDialog.title'
            | translate
                : {
                      taxReturn:
                          ((taxReturn.isAmendment
                              ? 'payroll.taxReturns.annualReturnAmended'
                              : 'payroll.taxReturns.annualReturn'
                          ) | translate: { year }),
                  }
    "
    [primaryButtonLabel]="'confirm'"
    [secondaryButtonLabel]="'cancel'"
>
    <p translate="payroll.taxForms.{{ packageTypeToBeDeleted }}.deleteDialog.disclaimer"></p>
</ui-confirmation-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'ADD_AMENDED_TAX_FORM'"
    header="payroll.taxForms.addAmendedTaxForm"
    (closing)="closeDialog(); addAmendedTaxForm?.clear()"
    size="small"
    [form]="addAmendedTaxForm?.form"
>
    @if (currentlyOpenDialog === 'ADD_AMENDED_TAX_FORM') {
        <app-add-amended-tax-form
            [employeesInAmendment]="employeeTaxFormsTables?.employeesInAmendment"
            [submittedReturn]="completedReturns()[0]"
            [hasQcPayrollFlag]="hasQcPayrollFlag()"
            #addAmendedTaxForm
        ></app-add-amended-tax-form>
    }
    <ui-dialog-footer>
        <ui-button (click)="closeDialog(); addAmendedTaxForm?.clear()">{{ 'cancel' | translate }}</ui-button>
        <ui-button
            [disabled]="!addAmendedTaxForm?.canSubmit()"
            (click)="addAmendedTaxSlip(addAmendedTaxForm)"
            type="primary"
            ><span translate="payroll.taxReturns.amendment.{{ hasQcPayrollFlag() ? 'addForms' : 'addForm' }}"></span
        ></ui-button>
    </ui-dialog-footer>
</ui-dialog>

<app-tax-form-consent-dialog [packageTypeToBeEmailed]="packageTypeToBeEmailed" />

<app-t4-dental-benefit-reminder-dialog
    [isOpen]="currentlyOpenDialog === 'T4_DENTAL_BENEFIT_REMINDER'"
    (closing)="closeDialog()"
    (onGenerateT4s)="closeDialog(); generateT4s()"
/>
